import { useMutation } from '@tanstack/react-query';
import moment from 'moment';
import { downloadSupportChatCSVAPI } from '../../../api/supportChat';
import { notifyError } from '../../../utils/notify';
import transformFiltersForApi from '../utils/transformFiltersForApi';

const downloadUserFeedbackCSV = async userFeedbackFilters => {
  const apiFilters = transformFiltersForApi(userFeedbackFilters);
  const res = await downloadSupportChatCSVAPI({
    ...apiFilters,
    hasCsatScore: true,
  });
  return res.data;
};

const triggerDownload = csvData => {
  const encodedUri = `data:application/csv;charset=utf-8,${encodeURIComponent(
    csvData
  )}`;
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute(
    'download',
    `user-feedback-${moment().format('YYYY-MM-DD')}.csv`
  );
  link.innerHTML = 'User Feedback';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const useDownloadUserFeedbackCSVMutation = () =>
  useMutation(data => downloadUserFeedbackCSV(data), {
    onSuccess: csvData => {
      triggerDownload(csvData);
    },
    onError: e => {
      notifyError(e, false, 'Error downloading CSV data');
    },
  });

export default useDownloadUserFeedbackCSVMutation;
